import React, { useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const TOMOS = [{
  icon: '📘',
  title: 'La Fórmula',
  subtitle: 'Entendés el problema y cómo cortarlo de raíz.',
  bullets: ['Qué es la fatiga de decisión a las 7 AM', 'Los 8 dolores reales de la merienda escolar', 'El Método M.E.R.I.E.N.D.A. paso a paso', 'La fórmula simple de una merienda equilibrada'],
  result: 'Ya sabés qué hacer. La pregunta de qué mandar deja de existir.'
}, {
  icon: '📗',
  title: '60 Meriendas',
  subtitle: 'Un banco completo que reemplaza los posts guardados.',
  bullets: ['15 ideas en menos de 5 minutos', '15 para dejar listas la noche anterior', '10 económicas y 10 para días de calor', '10 fáciles de transportar'],
  result: 'Nunca más te quedás parada frente a la heladera.'
}, {
  icon: '📙',
  title: '5 Minutos',
  subtitle: 'Para las mañanas en que todo salió mal.',
  bullets: ['15 fichas de emergencia por velocidad real', 'Protocolo de la mañana apurada en 4 pasos', 'La alacena de emergencia', '4 semanas de meriendas express'],
  result: 'Ni las peores mañanas te ganan.'
}, {
  icon: '📕',
  title: 'Recetario',
  subtitle: 'Domingo de alivio: preparás una vez.',
  bullets: ['10 recetas dulces y 10 saladas', 'Guía de conservación y congelado', '4 combinaciones de domingo planificadas', 'Las 5 recetas recomendadas para empezar'],
  result: 'Cinco mañanas sin esa pregunta.'
}, {
  icon: '📓',
  title: 'Económicas',
  subtitle: 'Gastar menos sin que parezca menos.',
  bullets: ['Comparativa real: improvisar vs. planificar', '10 ingredientes rendidores del mercado uruguayo', 'Frutas por temporada en Uruguay', '20 meriendas con costo estimado'],
  result: 'El mismo presupuesto. Tres veces más variedad.'
}, {
  icon: '📔',
  title: 'Planificador',
  subtitle: 'El sistema que hace que todo funcione.',
  bullets: ['4 semanas completas y calendario de 30 días', 'Listas de compras e inventario imprimibles', 'Registro de meriendas favoritas', 'Tabla de reemplazos inteligentes'],
  result: 'Un mes organizado en 15 minutos el domingo.'
}];
const BONUSES = [{
  title: 'Semáforo de Meriendas',
  value: '$60 UYU',
  description: 'Para que nunca más te preguntes si lo que mandaste estuvo bien.',
  items: ['Verde, amarillo y rojo sin tecnicismos', 'Aplicado a las 60 meriendas del banco', 'Las 6 reglas para usarlo sin culpa', 'Plantilla semanal para completar']
}, {
  title: 'Meriendas de Emergencia',
  value: '$60 UYU',
  description: 'Para las mañanas en que todo se desarmó.',
  items: ['10 fichas ordenadas por velocidad', 'El protocolo de crisis en 4 pasos', 'La alacena de emergencia siempre lista', '3 semanas de emergencia completas']
}, {
  title: 'Etiquetas para Lonchera',
  value: '$60 UYU',
  description: 'Un pequeño pedacito de casa que lo acompaña.',
  items: ['40 etiquetas imprimibles', 'Etiquetas de amor, días y motivación', 'Especiales para días importantes', 'En blanco para personalizar']
}];
const METHOD = [['M', 'Mirá lo que tenés', 'Comprás solo lo que falta'], ['E', 'Elegí una base', 'Cada día diferente'], ['R', 'Rotá para no repetir', 'Variedad real semana a semana'], ['I', 'Incluí variedad', 'Colores, texturas, opciones'], ['E', 'Equilibrá sin complicarte', 'Sin saber de nutrición'], ['N', 'No compliques', 'Máximo 10 minutos'], ['D', 'Dejá algo listo', '30 minutos el domingo = semana resuelta'], ['A', 'Adaptá a tu familia', 'Tu sistema, tus tiempos, tus reglas']];
export function TomosAndBonos() {
  const [activeTomo, setActiveTomo] = useState(0);
  const tomo = TOMOS[activeTomo];
  return <>
      <section className="bg-brand-lightBlue px-4 py-16" data-id="element-276" data-mp="1kzy303mh5tuq">
        <div className="mx-auto max-w-5xl" data-id="element-277" data-mp="1l2khkn7s99mg">
          <header className="mx-auto max-w-3xl text-center" data-id="element-278" data-mp="1pzu4nw7p9974">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-279" data-mp="1q1dlbnx9pm9f">
              El corazón del sistema
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-280" data-mp="1g8ga82uluzku">
              El Método M.E.R.I.E.N.D.A.
            </h2>
          </header>
          <div className="mt-10 overflow-hidden rounded-2xl border border-brand-sky bg-white shadow-sm" data-id="element-281" data-mp="16c38chowpff0">
            <div className="grid grid-cols-1 divide-y divide-brand-sky md:grid-cols-2 md:divide-x md:divide-y-0" data-id="element-282" data-mp="sclqkma132f5">
              {METHOD.map(([letter, step, outcome]) => <div key={`${letter}-${step}`} className="flex gap-4 p-4" data-id="element-283" data-mp="2mptncjhkdo3f">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-greenSoft font-display text-lg font-bold text-brand-green" data-id="element-284" data-mp="2mnqnl7qm0gli">
                    {letter}
                  </span>
                  <span data-id="element-285" data-mp="b2hvbps6u656">
                    <strong className="block text-brand-deep" data-id="element-286" data-mp="b39dnywry7di">{step}</strong>
                    <small className="text-brand-text" data-id="element-287" data-mp="pr475hilwfrn">{outcome}</small>
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-20" data-id="element-288" data-mp="ys2cc34s6tbt">
        <div className="mx-auto max-w-5xl" data-id="element-289" data-mp="yqr7dzzlnfj4">
          <header className="text-center" data-id="element-290" data-mp="tszjri5zmfkq">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-291" data-mp="trxxehjiu6np">
              Contenido completo
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-292" data-mp="13r5ixs0et7lw">
              ¿Qué vas a recibir cuando comprás hoy?
            </h2>
          </header>
          <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-6" data-id="element-293" data-mp="3ajpjxiv5qq8s">
            {TOMOS.map((item, index) => <button key={item.title} type="button" onClick={() => setActiveTomo(index)} className={`rounded-2xl border p-4 text-center transition-colors focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-sky ${activeTomo === index ? 'border-brand-orange bg-orange-50 shadow-sm' : 'border-slate-200 bg-white hover:border-brand-sky'}`} data-id="element-294" data-mp="3v6nrag78r5fd" data-mpi={index}>
                <span className="block text-3xl" data-id="element-295" data-mp="hz2tyijk32ld">{item.icon}</span>
                <span className="mt-2 block text-xs font-bold uppercase text-brand-gray" data-id="element-296" data-mp="m1hc10fehybl">
                  Tomo {index + 1}
                </span>
                <span className="mt-1 block font-display text-sm font-bold text-brand-deep" data-id="element-297" data-mp="qszczohfbywk">
                  {item.title}
                </span>
              </button>)}
          </div>
          <article key={tomo.title} className="mx-auto mt-8 max-w-3xl rounded-3xl border border-brand-sky bg-brand-lightBlue p-7 md:p-9" data-id="element-298" data-mp="10rx0qp70zoei">
            <div className="flex items-start gap-4" data-id="element-299" data-mp="2q80vxrgi92oe">
              <span className="text-4xl" data-id="element-300" data-mp="2q5o8iyrza03y">{tomo.icon}</span>
              <div data-id="element-301" data-mp="2l7mr0ia7a8ul">
                <p className="text-sm font-bold uppercase tracking-wider text-brand-orange" data-id="element-302" data-mp="2l7cvkf6dz9hi">
                  Tomo {activeTomo + 1}
                </p>
                <h3 className="font-display text-2xl font-bold text-brand-deep" data-id="element-303" data-mp="2bb02njio0znt">
                  {tomo.title}
                </h3>
                <p className="mt-2 font-medium text-brand-text" data-id="element-304" data-mp="38wxjlchecwxn">
                  {tomo.subtitle}
                </p>
              </div>
            </div>
            <ul className="mt-7 grid gap-3 md:grid-cols-2" data-id="element-305" data-mp="2z85v5ebjourh">
              {tomo.bullets.map(item => <li key={item} className="flex gap-2 font-medium text-brand-text" data-id="element-306" data-mp="2u9vwuuuixe1n">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-307" data-mp="3rqb40nnhhkz0" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-7 rounded-xl bg-white p-4 font-bold text-brand-deep" data-id="element-308" data-mp="2va6uyhx83z45">
              <span className="text-brand-orange" data-id="element-309" data-mp="300x1hyhdy80f">Resultado:</span>{' '}
              {tomo.result}
            </p>
          </article>
          <div className="mx-auto mt-12 max-w-3xl rounded-2xl border border-brand-sky bg-white p-6 shadow-sm" data-id="element-310" data-mp="2mb1x7dthk9t1">
            <h3 className="text-center font-display text-xl font-bold text-brand-deep" data-id="element-311" data-mp="2r9d5vl81oe9o">
              CADA TOMO INCLUYE:
            </h3>
            <div className="mt-6 grid gap-3 md:grid-cols-2" data-id="element-312" data-mp="3j015utxzfdlr">
              {['Sistema de planificación listo desde el día 1', 'Ideas organizadas por tu situación real', 'Recetas simples con ingredientes cotidianos', 'Guías de conservación y congelado', 'Planificadores y listas imprimibles', 'Precios orientativos en pesos uruguayos', '100% adaptado a Uruguay'].map(item => <p key={item} className="flex gap-2 font-medium text-brand-text" data-id="element-313" data-mp="1r0eubbb3e9hf">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-314" data-mp="1m0shh2z6ev95" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-base px-4 py-20" data-id="element-315" data-mp="1v2s0u1xnybf9">
        <div className="mx-auto max-w-5xl" data-id="element-316" data-mp="17cee8qxul4s2">
          <header className="text-center" data-id="element-317" data-mp="17d7dz7ye2u0p">
            <h2 className="font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-318" data-mp="13b2licjog3fn">
              + 3 Bonos Estratégicos incluidos
            </h2>
            <p className="mt-3 text-lg font-medium text-brand-text" data-id="element-319" data-mp="1h422yk30s7pu">
              Sin costo extra. En el MEGAPACK completo. Siempre.
            </p>
          </header>
          <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-320" data-mp="olemxj2vrivm">
            {BONUSES.map((bonus, index) => <article key={bonus.title} className="relative overflow-hidden rounded-2xl border border-brand-sky bg-white p-6 shadow-sm" data-id="element-321" data-mp="jm20v0ju2fu3" data-mpi={index}>
                <span className="absolute right-0 top-0 rounded-bl-xl bg-brand-orange px-3 py-1 text-xs font-bold text-white" data-id="element-322" data-mp="o1i08vo22swg">
                  BONO {index + 1}
                </span>
                <span className="text-3xl" data-id="element-323" data-mp="f1ljrhbtl0ch">🎁</span>
                <h3 className="mt-4 font-display text-xl font-bold text-brand-deep" data-id="element-324" data-mp="f0s8q45tvooj">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-brand-text" data-id="element-325" data-mp="5bijcw2dck44">{bonus.description}</p>
                <ul className="mt-5 space-y-2" data-id="element-326" data-mp="59fhnerut2jk">
                  {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm font-medium text-brand-text" data-id="element-327" data-mp="acnwqhbqiqw">
                      <span className="text-brand-orange" data-id="element-328" data-mp="3ng3l70799hn4">✓</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-6 border-t border-brand-sky pt-4 font-bold" data-id="element-329" data-mp="1y000irvejlrh">
                  <span className="text-brand-gray line-through" data-id="element-330" data-mp="1y242335tw8ol">
                    Valor: {bonus.value}
                  </span>{' '}
                  <span className="ml-2 text-brand-green" data-id="element-331" data-mp="27069c0g5nxkb">GRATIS</span>
                </p>
              </article>)}
          </div>
          <div className="mx-auto mt-10 max-w-2xl rounded-2xl bg-brand-orange p-6 text-center text-white shadow-lg" data-id="element-332" data-mp="2bz94mt6c2pf3">
            <p className="font-display text-xl font-bold" data-id="element-333" data-mp="1f7fadi737urd">
              🎁 $180 UYU en bonos — GRATIS
            </p>
            <p className="mt-1 text-orange-100" data-id="element-334" data-mp="1oa6nrnjix0ln">
              Incluidos en el MEGAPACK completo. Siempre.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-brand-deep px-4 py-20 text-white" data-id="element-335" data-mp="1t27wizhhg96x">
        <div className="mx-auto max-w-5xl" data-id="element-336" data-mp="vmat0odiliri">
          <header className="mx-auto max-w-2xl text-center" data-id="element-337" data-mp="vjgax3hz4a19">
            <h2 className="font-display text-3xl font-bold text-brand-orange md:text-4xl" data-id="element-338" data-mp="10jki22wzrset">
              Tres familias. Un sistema que se adapta.
            </h2>
            <p className="mt-5 text-xl leading-relaxed text-slate-200" data-id="element-339" data-mp="1ywonja5ez2at">
              En Uruguay hay tres tipos de familias que están leyendo esto.
            </p>
          </header>
          <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-340" data-mp="2cpo31c574wid">
            {[{
            icon: '🏠',
            title: 'LA FAMILIA QUE QUIERE PAZ MENTAL',
            body: 'Esa pregunta de todos los días te agota.',
            gain: 'Todo el mes planificado en una tarde. Las mañanas recuperadas.'
          }, {
            icon: '💰',
            title: 'LA FAMILIA CON PRESUPUESTO AJUSTADO',
            body: 'Querés darles buenas meriendas sin improvisaciones caras.',
            gain: 'Precios reales, frutas de estación y más variedad por menos.'
          }, {
            icon: '⭐',
            title: 'LA FAMILIA QUE QUIERE QUE VUELVA VACÍA',
            body: 'No alcanza con mandar algo. Querés que se lo coma.',
            gain: 'Ideas por situación y estrategias para involucrarlo en la elección.'
          }].map(profile => <article key={profile.title} className="rounded-2xl border border-white/20 bg-white/10 p-6" data-id="element-341" data-mp="2yxtiwy04205x">
                <span className="text-3xl" data-id="element-342" data-mp="3rke7xrt4606b">{profile.icon}</span>
                <h3 className="mt-4 font-display text-lg font-bold text-brand-orange" data-id="element-343" data-mp="3rn0oggxzfq0o">
                  {profile.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-200" data-id="element-344" data-mp="3hvmhxp7m5py1">
                  {profile.body}
                </p>
                <div className="mt-5 border-t border-white/15 pt-4" data-id="element-345" data-mp="3mswfxt92j9xh">
                  <strong className="text-sm" data-id="element-346" data-mp="ee4dlrr1v12d">Lo que te da:</strong>
                  <p className="mt-1 text-sm leading-relaxed text-brand-sky" data-id="element-347" data-mp="eckza6oyf038">
                    {profile.gain}
                  </p>
                </div>
              </article>)}
          </div>
        </div>
      </section>
    </>;
}